const FALLBACK_PROJECT_ID = 'dwpl-atlas';
const FALLBACK_AUTH_DOMAIN = `${FALLBACK_PROJECT_ID}.firebaseapp.com`;

export const getFirebaseProjectId = () => {
  const override = process.env.REACT_APP_FIREBASE_PROJECT_ID_OVERRIDE;
  if (override) return override;

  const envProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalhost && (!envProjectId || envProjectId === 'staging-atlas-2c10d')) {
    return FALLBACK_PROJECT_ID;
  }

  return envProjectId || FALLBACK_PROJECT_ID;
};

export const getFirebaseAuthDomain = () => {
  const override = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_OVERRIDE;
  if (override) return override;

  const envAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalhost && (!envAuthDomain || envAuthDomain.includes('staging-atlas-2c10d'))) {
    return FALLBACK_AUTH_DOMAIN;
  }

  return envAuthDomain || FALLBACK_AUTH_DOMAIN;
};

